/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Přihlaste se nebo si vytvořte účet`
};

const da_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Log ind eller opret konto`
};

const de_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Anmelden oder Konto erstellen`
};

const en_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Login or Create an Account`
};

const es_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Inicia sesión o crea una cuenta`
};

const fr_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Identifiez-vous ou créez un compte`
};

const hu_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Jelentkezz be vagy hozz létre egy fiókot`
};

const it_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Accedi o crea un account`
};

const nl_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Log in of maak een account aan`
};

const pl_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Zaloguj się lub zarejestruj`
};

const pt_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Faça login ou crie uma conta`
};

const sv_account_login_or_register = /** @type {(inputs: {}) => string} */ () => {
	return `Logga in eller skapa konto`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_login_or_register = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_login_or_register(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_login_or_register", locale)
	if (locale === "cs") return cs_account_login_or_register(inputs)
	if (locale === "da") return da_account_login_or_register(inputs)
	if (locale === "de") return de_account_login_or_register(inputs)
	if (locale === "en") return en_account_login_or_register(inputs)
	if (locale === "es") return es_account_login_or_register(inputs)
	if (locale === "fr") return fr_account_login_or_register(inputs)
	if (locale === "hu") return hu_account_login_or_register(inputs)
	if (locale === "it") return it_account_login_or_register(inputs)
	if (locale === "nl") return nl_account_login_or_register(inputs)
	if (locale === "pl") return pl_account_login_or_register(inputs)
	if (locale === "pt") return pt_account_login_or_register(inputs)
	return sv_account_login_or_register(inputs)
};
export { account_login_or_register as "account.login_or_register" }